// Saved audiences are references; only new manual audiences send a size.
export function audienceForPayload(audience, availableAudiences = []) {
    if (!audience || (audience.audience_size_id == null && audience.audience_id == null)) {
        return audience;
    }

    const idKey = audience.audience_size_id != null ? 'audience_size_id' : 'audience_id';
    const savedAudience = availableAudiences.find(option =>
        option[idKey] != null && String(option[idKey]) === String(audience[idKey])
    );
    return {
        type: 'existing_audience',
        audience_name: savedAudience?.audience_name ?? audience.audience_name ?? '',
        [idKey]: audience[idKey],
    };
}
